import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoURLDufy from '../../../../../assets/dufy.png';
import { formatearPrecio, cargarImagen } from '../../../../../utils/utils';

const generarPdfCotizacionMejorado = async(clienteSeleccionado, solicitudesFiltradas, semestreSeleccionado, configuracion) => {
  
  const paleta = {
    primario: '#16355E',
    secundario: '#428BCA',
    textoPrincipal: '#333333',
    textoSecundario: '#777777',
    borde: '#DDDDDD',
    fondoTitulo: '#F5F5F5'
  };
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height; // <<< MEJORA: Obtenemos el alto de la página
  const margin = 15;
  let currentY = 0; // Se inicializa en 0 para luego sumar el margen inicial

  // ===================================================================================
  // FUNCIÓN AUXILIAR PARA AÑADIR PÁGINA SI ES NECESARIO
  // ===================================================================================
  const checkPageBreak = (requiredHeight) => {
      if (currentY + requiredHeight > pageHeight - margin) {
          doc.addPage();
          currentY = margin; // Reiniciar Y en la nueva página
      }
  }
  
  currentY = margin; // Empezamos en el margen superior

  // ---------------------------------------------------------------------------------
  // SECCIÓN 1: ENCABEZADO (Sin cambios)
  // ---------------------------------------------------------------------------------
   try {
    const logoImg = await cargarImagen(logoURLDufy);

    // <<< PASO DE DEPURACIÓN: Imprime las dimensiones del logo en la consola del navegador
    console.log('Dimensiones del logo cargado:', { 
        width: logoImg.width, 
        height: logoImg.height 
    });

    // <<< MEJORA: Verificación para evitar errores si la imagen no carga bien
    if (!logoImg.width || !logoImg.height) {
        throw new Error('Las dimensiones del logo no son válidas. El ancho o el alto es cero.');
    }

    const logoHeight = 25; 
    const logoWidth = (logoImg.width * logoHeight) / logoImg.height;
    const logoX = (pageWidth - logoWidth) / 2;
    
    doc.addImage(logoImg, 'PNG', logoX, currentY, logoWidth, logoHeight);
    currentY += logoHeight + 5;

  } catch (error) {
    // Este error ahora es más descriptivo
    console.error("Error al procesar el logo para el PDF:", error);
    
    // Dejamos un espacio en el PDF para que no se monte con el texto
    currentY += 10;
  }
  
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.setTextColor(paleta.primario);
  doc.text('DUFY ASESORÍAS', pageWidth / 2, currentY, { align: 'center' });
  currentY += 7;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(paleta.textoSecundario);
  doc.text('#NosotrosLoHacemosPorTi', pageWidth / 2, currentY, { align: 'center' });
  currentY += 10;

  doc.setDrawColor(paleta.borde);
  doc.line(margin, currentY, pageWidth - margin, currentY);
  currentY += 10;
  
  // ---------------------------------------------------------------------------------
  // SECCIÓN 2: DATOS (Sin cambios)
  // ---------------------------------------------------------------------------------
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.primario);
  doc.text('COTIZACIÓN DE SERVICIOS', pageWidth / 2, currentY, { align: 'center' });
  currentY += 15;

  // --- Caja de Datos del Cliente ---
  // ... (Esta parte estaba bien, sin cambios)
  const boxWidth = pageWidth - (margin * 2);
  const boxPadding = 5;
  
  // Título de la caja
  doc.setFillColor(paleta.fondoTitulo);
  doc.setDrawColor(paleta.borde);
  doc.rect(margin, currentY, boxWidth, 8, 'FD');
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.textoPrincipal);
  doc.text('DATOS DEL CLIENTE', margin + boxPadding, currentY + 6);
  currentY += 8;

  // Contenido de la caja
  doc.setDrawColor(paleta.borde);
  doc.rect(margin, currentY, boxWidth, 28);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  const textOptions = { maxWidth: boxWidth - (boxPadding * 2) };
  let clienteY = currentY + 7;
  doc.text(`Nombre: ${clienteSeleccionado.nombrecompletoCliente}`, margin + boxPadding, clienteY, textOptions);
  clienteY += 6;
  doc.text(`Teléfono: ${clienteSeleccionado.numero || 'No especificado'}`, margin + boxPadding, clienteY, textOptions);
  clienteY += 6;
  doc.text(`Universidad: ${clienteSeleccionado.universidad || 'No especificada'}`, margin + boxPadding, clienteY, textOptions);
  clienteY += 6;
  doc.text(`Semestre: ${semestreSeleccionado}`, margin + boxPadding, clienteY, textOptions);
  currentY += 32;

  // --- Caja de Datos de la Cotización ---
  // ... (Esta parte estaba bien, sin cambios)
  const fechaCotizacion = new Date().toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
  const cotizacionNumero = `COT-${new Date().getFullYear()}-${clienteSeleccionado?.id?.toString().padStart(4, '0') || 'S-ID'}`;

  doc.setFillColor(paleta.fondoTitulo);
  doc.setDrawColor(paleta.borde);
  doc.rect(margin, currentY, boxWidth, 8, 'FD');
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('DATOS DE LA COTIZACIÓN', margin + boxPadding, currentY + 6);
  currentY += 8;
  
  doc.setDrawColor(paleta.borde);
  doc.rect(margin, currentY, boxWidth, 8);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text(`Nº Cotización: ${cotizacionNumero}`, margin + boxPadding, currentY + 6);
  doc.text(`Fecha de Emisión: ${fechaCotizacion}`, pageWidth / 2, currentY + 6);
  currentY += 15;

  // ---------------------------------------------------------------------------------
  // SECCIÓN 3: TABLA DE SERVICIOS
  // <<< MEJORA: `autoTable` ahora manejará los saltos de página automáticamente
  // ---------------------------------------------------------------------------------
  const tableData = [];
  let totalGeneral = 0;

  // ... (Tu lógica para construir tableData es correcta y no necesita cambios)
  const solicitudesPorMateria = solicitudesFiltradas.reduce((grupos, solicitud) => {
    const materia = solicitud.proPlataforma?.materia || 'Sin Materia';
    if (!grupos[materia]) grupos[materia] = [];
    grupos[materia].push(solicitud);
    return grupos;
  }, {});

  Object.entries(solicitudesPorMateria).forEach(([materia, solicitudes]) => {
    tableData.push([{ content: materia.toUpperCase(), colSpan: 4, styles: { fontStyle: 'bold', fillColor: '#F0F0F0', textColor: paleta.primario, halign: 'left' } }]);
    let subtotalMateria = 0;
    solicitudes.forEach((solicitud) => {
      const precio = solicitud.proPlataforma?.precioEmpresa || 0;
      subtotalMateria += precio;
      tableData.push([
        solicitud.proPlataforma?.fase || 'N/A',
        new Date(solicitud.proPlataforma.fechaRealUnad).toLocaleDateString('es-ES'),
        formatearPrecio(precio),
        `#${solicitud.id}`
      ]);
    });
    tableData.push([
      { content: 'Subtotal Materia', colSpan: 2, styles: { fontStyle: 'bold', textColor: paleta.textoPrincipal, halign: 'right' } },
      { content: formatearPrecio(subtotalMateria), styles: { fontStyle: 'bold', textColor: paleta.textoPrincipal, halign: 'right' } },
      ''
    ]);
    totalGeneral += subtotalMateria;
  });


  autoTable(doc, {
    startY: currentY,
    head: [['Descripción del Servicio', 'Fecha Entrega', 'Precio', 'Referencia']],
    body: tableData,
    theme: 'grid',
    headStyles: { fillColor: paleta.primario, textColor: '#FFFFFF', fontStyle: 'bold', halign: 'center' },
    styles: { fontSize: 9, cellPadding: 3, textColor: paleta.textoPrincipal },
    columnStyles: {
      0: { cellWidth: 'auto' },
      1: { halign: 'center', cellWidth: 35 },
      2: { halign: 'right', cellWidth: 40 },
      3: { halign: 'center', cellWidth: 25 }
    },
    // <<< MEJORA: Aseguramos que currentY se actualice después de la tabla, incluso si hay saltos de página
    didDrawPage: (data) => {
        currentY = data.cursor.y;
    }
  });

  currentY = doc.lastAutoTable.finalY;

  // ---------------------------------------------------------------------------------
  // SECCIÓN 4: TOTAL Y CRONOGRAMA DE PAGOS
  // ---------------------------------------------------------------------------------
  checkPageBreak(30); // <<< MEJORA: Verificamos si hay espacio para el total
  currentY += 5;
  const totalBoxY = currentY;
  const totalBoxWidth = 70;
  const totalBoxX = pageWidth - margin - totalBoxWidth;
  
  doc.setFillColor(paleta.fondoTitulo);
  doc.rect(totalBoxX, totalBoxY, totalBoxWidth, 8, 'F');
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.primario);
  doc.text('TOTAL:', totalBoxX + 5, totalBoxY + 6);
  doc.text(formatearPrecio(totalGeneral), pageWidth - margin, totalBoxY + 6, { align: 'right' });
  currentY += 15;

  const planPagosData = generarPlanDePagos(solicitudesFiltradas);

  if (planPagosData.length > 1) {
    checkPageBreak(40); // <<< MEJORA: Verificamos si hay espacio para el título y la tabla de pagos
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(paleta.textoPrincipal);
    doc.text('Cronograma de Pagos:', margin, currentY);
    currentY += 6;

    autoTable(doc, {
      startY: currentY,
      head: [['N°', 'Concepto', 'Fecha de Pago', 'Valor']],
      body: planPagosData,
      theme: 'grid',
      headStyles: { fillColor: paleta.secundario, textColor: '#FFFFFF', fontStyle: 'bold' },
      styles: { fontSize: 9, cellPadding: 3 },
      didDrawPage: (data) => {
        currentY = data.cursor.y;
      }
    });
    currentY = doc.lastAutoTable.finalY;
  }

  currentY += 10; 

  // ---------------------------------------------------------------------------------
  // SECCIÓN 5: TÉRMINOS Y CONDICIONES
  // ---------------------------------------------------------------------------------
  checkPageBreak(30); // <<< MEJORA: Verificamos si hay espacio para el título
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.textoPrincipal);
  doc.text('Términos y Condiciones:', margin, currentY);
  
  currentY += 6;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(paleta.textoSecundario);

  const terminos = [
    '1. VIGENCIA: Esta cotización es válida por 15 días calendario desde su fecha de emisión.',
    '2. PRECIOS Y MONEDA: Los precios están expresados en Pesos Colombianos (COP).',
    '3. ALCANCE DEL SERVICIO: El valor total incluye la realización completa de las actividades descritas en la plataforma académica, tales como foros, actividades colaborativas, quizzes, trabajos y entregables finales.',
    '4. GARANTÍA Y CALIDAD: Garantizamos trabajos 100% originales, libres de plagio e IA. Para asegurar la calidad, contamos con reportes de similitud de Turnitin que pueden ser presentados al cliente. Nuestro servicio está respaldado por la garantía de notas de Dufy Asesorías.',
    '5. FORMA DE PAGO: Ofrecemos formas de pago flexibles. Los pagos se pueden realizar a medida que se avanza en las actividades y podemos diseñar un plan de pagos personalizado que se ajuste a tus necesidades.',
    '6. COMUNICACIÓN: Se mantendrá al cliente informado sobre el progreso y el estado de sus notas de manera periódica a través de nuestros canales de comunicación.',
    '7. RESPONSABILIDADES DEL CLIENTE: Es responsabilidad del cliente proporcionar los accesos, el material y la información necesaria de manera oportuna para el correcto desarrollo de las actividades.',
    '8. MODIFICACIONES: Cualquier servicio o actividad no contemplada en esta cotización estará sujeta a una reevaluación y puede generar costos adicionales.',
    '9. CONFIDENCIALIDAD: En Dufy Asesorías, tu privacidad es nuestra prioridad. Nos comprometemos a manejar toda tu información personal y académica con la máxima discreción. Tus datos serán almacenados de forma segura y bajo ninguna circunstancia serán compartidos con terceros.'
  ];

  terminos.forEach((termino) => {
    const lines = doc.splitTextToSize(termino, pageWidth - (margin * 2));
    const requiredHeight = lines.length * 5 + 2; // <<< CORRECCIÓN: Usamos 5 como altura de línea
    
    checkPageBreak(requiredHeight); // <<< MEJORA: Verificamos espacio ANTES de dibujar cada término

    doc.text(lines, margin, currentY);
    // <<< CORRECCIÓN: Aumentamos la altura de línea de 4 a 5 para evitar solapamiento
    currentY += (lines.length * 5) + 2; 
  });

  // ---------------------------------------------------------------------------------
  // SECCIÓN 6: PIE DE PÁGINA (Se dibujará al final de la última página)
  // ---------------------------------------------------------------------------------
  // <<< MEJORA: Se asegura que el footer siempre aparezca al final
  const finalPageHeight = doc.internal.pageSize.height;
  
  doc.setDrawColor(paleta.borde);
  doc.line(margin, finalPageHeight - 30, pageWidth - margin, finalPageHeight - 30);
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(paleta.textoSecundario);
  doc.text('¡Gracias por confiar en nosotros!', pageWidth / 2, finalPageHeight - 25, { align: 'center' });

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.primario);
  doc.text('# Nosotros Lo Hacemos Por Ti', pageWidth / 2, finalPageHeight - 19, { align: 'center' });

  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(paleta.textoSecundario);
  doc.text(`Web: www.dufyasesorias.com | Email: asesorandres@dufyasesorias.com`, pageWidth / 2, finalPageHeight - 12, { align: 'center' });

  const nombreArchivo = `Cotizacion_${clienteSeleccionado.nombrecompletoCliente}_${semestreSeleccionado}_${fechaCotizacion.replace(/\//g, '-')}.pdf`;
  doc.save(nombreArchivo);
};

// ===================================================================================
// FUNCIÓN PARA GENERAR EL PLAN DE PAGOS (Esta función estaba correcta)
// ===================================================================================
const generarPlanDePagos = (solicitudes) => {
    // Tu función original estaba bien calculada y no necesita cambios.
    // La he dejado aquí para mantener la integridad del código.
    if (!solicitudes || solicitudes.length === 0) {
        return [];
    }
    
    const entregasPorFecha = solicitudes.reduce((acc, sol) => {
        const fechaClave = new Date(sol.proPlataforma.fechaRealUnad).toISOString().split('T')[0];
        if (!acc[fechaClave]) {
            acc[fechaClave] = 0;
        }
        acc[fechaClave] += sol.proPlataforma?.precioEmpresa || 0;
        return acc;
    }, {});

    const fechasOrdenadas = Object.keys(entregasPorFecha).sort();
    if (fechasOrdenadas.length === 0) {
        return [];
    }

    const gruposDePago = [];
    let grupoActual = {
        fechaInicio: new Date(fechasOrdenadas[0] + 'T00:00:00'),
        fechaFin: new Date(fechasOrdenadas[0] + 'T00:00:00'),
        total: entregasPorFecha[fechasOrdenadas[0]]
    };

    for (let i = 1; i < fechasOrdenadas.length; i++) {
        const fechaActual = new Date(fechasOrdenadas[i] + 'T00:00:00');
        const diffDays = (fechaActual - grupoActual.fechaFin) / (1000 * 60 * 60 * 24);

        if (diffDays <= 6) {
            grupoActual.fechaFin = fechaActual;
            grupoActual.total += entregasPorFecha[fechasOrdenadas[i]];
        } else {
            gruposDePago.push(grupoActual);
            grupoActual = {
                fechaInicio: fechaActual,
                fechaFin: fechaActual,
                total: entregasPorFecha[fechasOrdenadas[i]]
            };
        }
    }
    gruposDePago.push(grupoActual);

    const resumenData = [];
    const formateadorFecha = new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit' });
    
    const formatearRango = (grupo) => {
        const inicio = formateadorFecha.format(grupo.fechaInicio);
        const fin = formateadorFecha.format(grupo.fechaFin);
        return inicio === fin ? `del ${inicio.substring(0,5)}` : `del ${inicio.substring(0,5)} al ${fin.substring(0,5)}`;
    };
    
    // Simplificando las fechas en el concepto para que no incluyan el año
    const formateadorFechaPago = new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });


    if (gruposDePago.length > 0) {
        const primerGrupo = gruposDePago[0];
        const fechaPrimerPago = new Date(primerGrupo.fechaInicio);
        fechaPrimerPago.setDate(fechaPrimerPago.getDate() - 14);
        const fechaPrimerPagoStr = `Máximo hasta el ${formateadorFechaPago.format(fechaPrimerPago)}`;

        resumenData.push([
            '1er pago',
            `Adelanto trabajos ${formatearRango(primerGrupo)}`,
            fechaPrimerPagoStr,
            formatearPrecio(primerGrupo.total * 0.5)
        ]);
    }

    for (let i = 0; i < gruposDePago.length - 1; i++) {
        const grupoActual = gruposDePago[i];
        const grupoSiguiente = gruposDePago[i + 1];
        
        const fechaDePago = new Date(grupoActual.fechaFin);
        fechaDePago.setDate(fechaDePago.getDate() - 2);

        const valorPago = (grupoActual.total * 0.5) + (grupoSiguiente.total * 0.5);
        
        resumenData.push([
            `${i + 2}° pago`,
            `Saldo trabajos ${formatearRango(grupoActual)} y Adelanto ${formatearRango(grupoSiguiente)}`,
            formateadorFechaPago.format(fechaDePago),
            formatearPrecio(valorPago)
        ]);
    }


    if (gruposDePago.length > 0) {
        const ultimoGrupo = gruposDePago[gruposDePago.length - 1];
        resumenData.push([
            `${gruposDePago.length + (gruposDePago.length > 1 ? 0 : 1)}° pago`,
            `Saldo final trabajos ${formatearRango(ultimoGrupo)}`,
            formateadorFechaPago.format(ultimoGrupo.fechaFin),
            formatearPrecio(ultimoGrupo.total * 0.5)
        ]);
    }

    return resumenData;
};


export default generarPdfCotizacionMejorado;